<template>
  <DialogContainer v-model="dialogObj">
    <template v-slot:dialogSlot>
      <div class="business-body custom-form">
        <el-row>
          <el-col :span="12" class="label-val">
            <span class="label">货主姓名：</span>
            <span class="value">货发</span>
          </el-col>
          <el-col :span="12" class="label-val">
            <span class="label">联系电话：</span>
            <span class="value">货发</span>
          </el-col>
          <el-col :span="12" class="label-val">
            <span class="label">客户归属：</span>
            <span class="value">货发</span>
          </el-col>
          <el-col :span="12" class="label-val">
            <span class="label">注册时间：</span>
            <span class="value">货发</span>
          </el-col>
        </el-row>
        <div class="title-box">
          <el-image :src="cheImage" class="title-label"></el-image>订单状态
        </div>
        <el-row :gutter="20">
          <el-form ref="form" :model="form" :rules="rules" label-position="top">
            <el-col :span="12">
              <el-form-item label="所属机构：" prop="realPrice">
                <el-select
                  style="width: 100%"
                  clearable
                  v-model="form.status"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in $dict.statusOptions"
                    :key="item.dictCode"
                    :label="item.dictLabel"
                    :value="item.dictCode"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="司机：" prop="plateNumber">
                <el-select
                  style="width: 100%"
                  clearable
                  v-model="form.status"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in $dict.statusOptions"
                    :key="item.dictCode"
                    :label="item.dictLabel"
                    :value="item.dictCode"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-form>
        </el-row>
      </div>
    </template>
  </DialogContainer>
</template>

<script>
import DialogContainer from "@/components/Dialog.vue";
import { validatePhone } from "@/utils/validate";
import { addInfo, editInfo, setReal } from "./api";
import { getRoleSelect } from "@/views/commonApi";
import { userSms } from "@/views/login/api";
export default {
  name: "AddOrEdit",
  components: {
    DialogContainer,
  },
  data() {
    return {
      cheImage: require("@/assets/imgs/title.png"),
      dialogObj: {
        loading: false,
        btnLoading: false,
        width: "30%",
        show: false,
        title: "修改客户归属",
        closeOnClickModal: false,
        confirmFn: this.submitForm,
        beforeClose: (v) => {
          this.form = this.$options.data().form;
          if (this.$refs.form) this.$refs.form.resetFields();
          this.dialogObj.show = false;
          this.dialogObj.btnLoading = false;
        },
      },
      form: {
        orderId: "",
        realPrice: "",
        realPhone: "",
        plateNumber: "",
      },
      rules: {
        // realPrice: [{ required: true, message: "设备编号不能为空" }],
        // realPhone: [{ required: true, message: "设备位置信息不能为空" }],
      },
    };
  },
  mounted() {},
  methods: {
    init(row) {
      if (!!row) {
        this.form = Object.assign({}, row);
      }
      this.dialogObj.show = true;
    },

    // 提交数据
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.dialogObj.btnLoading = true;
          const par = {
            orderId: this.form.orderId,
            realPrice: this.form.realPrice,
            realPhone: this.form.realPhone,
            plateNumber: this.form.plateNumber,
          };
          setReal(par)
            .then((res) => {
              this.dialogObj.btnLoading = false;
              if (res.code === 200) {
                this.$message.success("审批成功");
                this.$parent.handleAddOrEditSuccess("edit");
                this.dialogObj.beforeClose();
              }
            })
            .catch((e) => {
              this.dialogObj.btnLoading = false;
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.business-body {
  box-sizing: border-box;
  .label-val {
    margin-bottom: 0.16rem;
  }
}
</style>
